export default __webpack_public_path__ + "static/media/sun-first-logo.0cae9244.png";